import *as THREE from 'three'
import * as config from './config'

export default class {
  constructor({type, ...props}) {
    this.type = type
    this.props = props
    this.savedP = new THREE.Vector3(0, 0, 0)
    
    switch(type) {
      case 'ground': {
        this.createGround()
        break
      }

      case 'chain': {
        this.createChainOfObjects()
        break
      }
      
      case 'kinematic': {
        this.createKinematic()

        break
      }

      case 'box': {
        this.createBox()
        
        break
      }
      
      case 'plane': {
        this.createPlane()

        break
      }
      
      case 'sphere': {
        this.createSphere()
        break
      }
    }
  }

  createBox() {
    const { size, rotation, world, position, onChange=f=>f } = this.props

    this.physical = world.add({
      type: 'box',
      size: size,
      pos: position,
      rot: rotation.map(i => THREE.Math.radToDeg(i)),
      move: true,
      belongsTo: 2,
      // move: true,
    })
  }

  createChainOfObjects() {
    const { world, list, rotations } = this.props
    
    this.objects = list.map((item, i, arr) => {
      const { box: visual, size } = item

      const defaults = {position: visual.position.clone(), quaternion: visual.quaternion.clone()}
      
      const prevItem = arr[i - 1] 
      
      const o = {
        type: 'box',
        pos: config.parameters[i].position,
        rot: config.parameters[i].rot,
        move: true,
        // collision: true,

        // density: 10000,
        restitution: 0,
        // kinematic: config.staticBonesCount > i ,
        
        // friction: 0,
        // impulse: false,
        name: visual.name,
        friction: 2,

        size: size
      }

      const physical = world.add(o)

      if(i === 0) {
        this.mainBone = { physical, visual }
        this.physical = physical
      }

      
      if(i > 0) {
        const offsetA = prevItem.size[2]/2 + 2;           
        const offsetB = size[2]/2 + 2;
    
        const p1 = [1,  1, offsetA ]
        const p2 = [1, 1, -offsetB ]

        world.add({
          type: 'joint',
          body1: prevItem.box.name, 
          body2: visual.name,
          pos1: p1,
          pos2: p2,
          // friction: -20,

          spring: [ 20, -.5],
          // min:0,
          // max: 0,
          collision: true,
        })
      }

      return { physical, visual, defaults } 
    })
  }

  createKinematic() {
    const { width, height, depth, position, move, friction, rotation = [0,0,0], name, world } = this.props 

    const geo = new THREE.BoxGeometry(width, height, depth)
    const mat = new THREE.MeshPhongMaterial({
      color: '#000999', 
      side: THREE.DoubleSide, 
      transparent: true, 
      opacity: .3
    })
    this.visual = new THREE.Mesh(geo, mat)
    this.visual.rotation.fromArray(rotation)
    this.visual.name = name
    this.visual.position.fromArray(position)

    this.physical = world.add({
      type: 'box',
      size: [width, height, depth],
      pos: position,
      density: 10000,
      restitution:0,
      friction: friction !== undefined ? friction :  0,
      collision: true,
      kinematic: true,
      // move: !name.includes('bottom'),
      move: move === undefined ? move : true,
      // axis: [ 1, 1, 1 ], max: 45, min: -45, spring:[ 100, 0.2 ]
    })

  }
  
  createPlane() {
    const { width, height, initialPosition, rotation, depth, world } = this.props 
    
    const geo = new THREE.BoxGeometry(width, depth || .1, height)
    const mat = new THREE.MeshPhongMaterial({
      color: '#df32f1', 
      side: THREE.DoubleSide, 
      transparent: true, 
      opacity: .3
    })
    
  this.visual = new THREE.Mesh(geo, mat)
    this.visual.position.fromArray(initialPosition)
    if(rotation) this.visual.rotation.fromArray(rotation)
    
    this.physical = world.add({
      type: 'box',
      collision: false,
      size: [width, depth || .1, height],
      pos: initialPosition,
      density: 200 * 2,
      rot: rotation.map(i => THREE.Math.radToDeg(i)) || [0, 0, 0],
    })
  }


  createSphere() {
    const { size, initialPosition, world, move } = this.props 

    this.physical = world.add({
      type: 'sphere',
      pos: initialPosition,
      rot: [0,0,0],
      friction: 4000,
      // destiny: 0.0000000001,
      size,
      move,
      collision: true
    })

    const sG = new THREE.SphereGeometry(...size)
    const sphere = new THREE.Mesh(sG, new THREE.MeshStandardMaterial({color: '#00FF00'}))

    
    this.visual = sphere
    this.visual.name = 'spheree!'
    console.log(sphere, 'spheree!')
    this.visual.position.set(...initialPosition)
  }

  createGround() {
    this.physical = this.props.world.add({size: [50000, 10, 50000], pos: [0, -10, 0], destiny: 1000, friction: 100})
    this.visual = null
  }

  setAll({position, quaternion, index}) {
    const [x, y, z, w] = quaternion.toArray()
    const [px, py, pz] = position.toArray()
    
    if(index !== undefined) {
      const targetPhysical = this.objects[index].physical

      targetPhysical.setPosition({x: px, y: py, z: pz})
      targetPhysical.setQuaternion({x, y, z, w})
      // targetPhysical.resetPosition(px, py, pz)
      // targetPhysical.resetQuaternion({x, y, z, w})
    } else {
      this.physical.setPosition({x: px, y: py, z: pz})
      this.physical.setQuaternion({x, y, z, w})
      // this.physical.setPosition({x: px, y: py, z: pz})
      // this.physical.setQuaternion({x, y, z, w})
      // this.physical.setQuaternion({x, y, z, w})
    }
  }

  update = (_, hard = false) => {
    if(this.type === 'chain') {
      this.objects.forEach((item, i) => {
        
        const { physical, visual } = item
        
        if(!i && hard) {
          const {rotation: { x, y ,z}, position} = visual 

          physical.setRotation({x: THREE.Math.radToDeg(x), y: THREE.Math.radToDeg(y), z: THREE.Math.radToDeg(z)})
          physical.setPosition(position)
        } else {
          const {quaternion: q, position: p} = physical
          
          visual.position.set(p.x, p.y, p.z)
          visual.quaternion.set(q.x, q.y, q.z, q.w)
        }
      })


    }
    if(this.type === 'box') {
      this.props.onChange(this.physical)
    }
    
    if(this.type === 'plane') {
      const {x, y, z} = this.physical.position
      const q = this.physical.quaternion
      
      this.visual.position.set(x, y, z)
      this.visual.quaternion.set(q.x, q.y, q.z, q.w)
    }
    
    if(this.type === 'sphere') {
      const {x, y, z} = this.physical.position
      const q = this.physical.quaternion
      
      
      this.visual.position.set(x, y, z)
      this.visual.quaternion.set(q.x, q.y, q.z, q.w)
    }
  }
}